<template>
	<div style="height: 100%;">
		<div v-show="!emptyState" ref="charts" style="height: 100%;"></div>
		<c-empty v-show="emptyState"></c-empty>
	</div>
</template>

<script>
	import {getStore, mapStore} from '@deanwu/vue-component-library'
	import * as echarts from 'echarts'

	export default {
		props: {
			data: Array
		},

		data() {
			return {
				...getStore(this, 'digitalStore'),
				emptyState: false
			}
		},

		computed: {
			...mapStore('digitalStore', ['registerChart', 'px'])
		},

		watch: {
			data() {
				this.init();
			}
		},

		mounted() {
			this.echartsObj = echarts.init(this.$refs.charts);
			this.registerChart(this.echartsObj);
			this.init();
		},

		methods: {
			init() {
				this.emptyState = !this.data.length;
				this.$nextTick(() => {
					this.echartsObj.resize();
					this.echartsObj.clear();
					this.echartsObj.setOption({
						color: ['#02F4FF', '#19AEF1', '#FF414A', '#FFBA00', '#0A71F8', '#5470c6', '#91cc75', '#fac858', '#ee6666', '#73c0de', '#3ba272', '#fc8452', '#9a60b4', '#ea7ccc'],
						tooltip: {
							trigger: 'item'
						},
						series: {
							type: 'pie',
							center: ['50%', '50%'],
							radius: ['45%', '75%'],
							label: {
								formatter: '{b}\n{d}%',
								fontSize: this.px(13),
								color: '#fff'
							},
							data: this.data.map(item => {
								return {
									name: item.dimension_name,
									value: item.value
								}
							})
						}
					});
				});
			}
		}
	}
</script>

